var React = require('react');

function SVGIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","fillRule":"evenodd","clipRule":"evenodd","d":"M12.8555 4L11.4455 5.41L17.0255 11H4.85547V13H17.0255L11.4455 18.59L12.8555 20L20.8555 12L12.8555 4Z"}));
}

SVGIcon.defaultProps = {"viewBox":"0 0 25 24"};

module.exports = SVGIcon;

SVGIcon.default = SVGIcon;
